import { CSSObject } from '@emotion/react'
import { fontSizes, fonts } from '@opallabs/pulsar'

const thumbnailDimensions = {
  height: '221px',
  width: '125px',
}

const contentWrapper: CSSObject = {
  height: thumbnailDimensions.height,
  paddingTop: '1px',
  width: thumbnailDimensions.width,
}

const thumbnailFooter: CSSObject = {
  alignItems: 'center',
  color: 'white',
  display: 'flex',
  fontFamily: fonts.helvetica,
  fontSize: fontSizes.xxSmall,
  justifyContent: 'space-between',
  margin: '0 0 9px 7px',
  position: 'relative',
  top: '-22px',
  width: '36px',
}

const assetBaseStyles: CSSObject = {
  height: thumbnailDimensions.height,
  width: thumbnailDimensions.width,
}

const assetStyles: CSSObject = {
  video: {
    width: '100%',
    height: '100%',
  },
}

const styles = {
  contentWrapper,
  thumbnailFooter,
  assetBaseStyles,
  assetStyles,
}

export { styles }
